package com.macrofocus.eflux.network

import com.macrofocus.eflux.network.logical.LogicalBusId
import com.macrofocus.eflux.network.logical.logicalBranchIdOf
import com.macrofocus.eflux.network.physical.Branch
import org.molap.network.Link

class CombinedBranches(override val from : LogicalBusId, override val to : LogicalBusId, val branch: Branch) : Link<LogicalBusId, LogicalBusId> {
    val logicalBranchId = logicalBranchIdOf(from, to, branch.record.ckt)

    val sbase = branch.sbase

    val met = branch.met
    val met_k = branch.met_k
    val met_m = branch.met_m

    val va_k = branch.va_k
    val va_m = branch.va_m

    val va = branch.va
    val dva = branch.dva

    val vm_k = branch.vm_k
    val vm_m = branch.vm_m

    val vm = branch.vm
    val dvm = branch.dvm

    val x = branch.x

    val p = branch.p
    val q = branch.q
    val abs_s = branch.abs_s

    val ratea = branch.ratea
    val rateb = branch.rateb
    val ratec = branch.ratec

    val pratea = branch.pratea
    val onepratea = branch.onepratea
    val sratea = branch.sratea

    val baskv = branch.baskv

    override fun equals(other: Any?): Boolean {
        if(!(other is CombinedBranches)) return false

        return logicalBranchId.equals(other.logicalBranchId)
    }

    override fun hashCode(): Int {
        return logicalBranchId.hashCode()
    }

    /**
     * Returns string representation of the [Link] including its [from] and [to] values.
     */
    public override fun toString(): String = logicalBranchId.name
}